export const subcategoriesDisplayNamesMapper = {
	monthlyTotal: 'Monthly Total',
	freightMonthlyTotal: 'Freight',
	laborMonthlyTotal: 'Labor',
	materialMonthlyTotal: 'Material',
	miscMonthlyTotal: 'Misc',
	taxMonthlyTotal: 'Tax',
	travelMonthlyTotal: 'Travel',
};
